import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PropsWithChildren } from 'react'
import { AxiosError } from 'axios'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30_000,
			retry: (failureCount, error) => {
				if (failureCount >= 3) {
					return false
				}

				if (error && (error as AxiosError).isAxiosError) {
					const { status } = error as AxiosError

					return !status || ![401, 403].includes(status)
				}

				return true
			},
		},
	},
})

export default function ReactQueryProvider({ children }: PropsWithChildren) {
	return (
		<QueryClientProvider client={queryClient}>
			{children}
			<ReactQueryDevtools />
		</QueryClientProvider>
	)
}
